import React from 'react'
// Ant Design
import { Flex, Typography, Skeleton, Pagination } from 'antd'
// React Icons
import { LuLayoutDashboard } from "react-icons/lu"
// Config
import { getConfig } from '../../config'
const { Text  } = Typography

export const ListViews = ({ views, selectView, setSelectView, setIsGraph, loading, setError404, page, setPage, total }) => {

    const onSelectView = (view) => {
        setSelectView(view)
        setIsGraph(false)
        setError404(false)
    }

    function SkeletonList() {
        return (
            Array.from({ length: 7 }).map((_, index) => (
                <Flex key={index} align="center" style={{ minHeight: "80px", paddingRight: "10px" }}>
                    <Skeleton.Avatar active size="large" shape="square" />
                    <Flex vertical style={{ marginLeft: "10px" }}>
                        <Skeleton.Input active size="small" />
                    </Flex>
                </Flex>
            ))
        )
    }

    function List() {
        return (
            <>
                {views.map((view, index) => (
                    <Flex key={index + 1} onClick={() => onSelectView(view)} align="center" style={{ minHeight: "80px", paddingRight: "10px", cursor: "pointer", boxShadow: (selectView && selectView._id === view._id) && "0px 6px 12px rgba(0, 0, 0, 0.2)", transition: "box-shadow 0.3s ease" }}>
                        <LuLayoutDashboard style={{ fontSize: "35px", marginRight: "10px", color: getConfig("colorSecundario") }} />
                        <Flex vertical>
                            <Text style={{ fontSize: "16px", fontWeight: "600" }}>{view.name_view}</Text>
                        </Flex>
                    </Flex>
                ))}
            </>
        )
    }


    return (
        <Flex className="skin-scroll" vertical style={{ position: "relative", width: "25%", height: "calc(100vh - 70px)", overflowY: "auto", borderRight: `2px solid ${getConfig("colorPrimario")}` }}>
            {loading ? <SkeletonList /> : <List />}

            <Flex justify="center" style={{ position: "sticky", width: "100%", bottom: 0, left: 0, backgroundColor: "#fff", zIndex: "1" }}>
                <Pagination 
                    simple={{ readOnly: true }} 
                    onChange={(newPage) => setPage(newPage)} 
                    total={total}
                    pageSize={10}
                    showSizeChanger={false}
                />
            </Flex>
        </Flex>
    )
}
